import Landing from "./components/Landing";
import Main from "./components/Main";
import Contacts from "./components/Contacts";

export default function App() {
  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
  const isTablet = navigator.maxTouchPoints > 0;
  return (
    <div className={`w-screen select-none overflow-hidden`}>
      <Landing {...{isMobile, isTablet}} />
      <Main {...{isMobile, isTablet}} />
      <Contacts />
    </div>
  )
};